// Order Positioning Setup API
import queryString from 'query-string'
import {
    RequestConfigFunction,
} from 'app/types/request.types'
import {
    OrderModificationType,
} from 'app/enums/label.enums'

type OrderPositioningSetupRequests = {
    updateOriginServiceCenter: RequestConfigFunction<{
        orderNumber: string,
        data?: Record<string, any>,
    }>,
    getPositioningSetup: RequestConfigFunction<{
        orderNumber: string,
    }>,
    updatePositioningSetup: RequestConfigFunction<{
        orderNumber: string,
        data?: Record<string, any>,
        modificationType?: OrderModificationType
    }>,
}

const orderPositioningSetupRequests: OrderPositioningSetupRequests = {
    updateOriginServiceCenter: ({
        orderNumber,
        data = {},
    }) => {
        return {
            url: `order/${orderNumber}/originservicecenter`,
            method: 'PATCH',
            data,
        }
    },
    getPositioningSetup: ({
        orderNumber,
    }) => {
        return {
            url: `order/${orderNumber}/positioning-setup`,
            method: 'GET',
        }
    },
    updatePositioningSetup: ({
        orderNumber,
        data = {},
        modificationType,
    }) => {
        return {
            url: queryString.stringifyUrl({
                url: `order/${orderNumber}/positioning-setup`,
                query: modificationType ? {
                    modificationType,
                } : undefined,
            }),
            method: 'PATCH',
            data,
        }
    },
}

export default orderPositioningSetupRequests
